import dayjs, { Dayjs } from 'dayjs'
import { assertPrimitives } from './assertion.util'

export const toNumber = (value: string | number): number => {
  assertPrimitives(value, 'string', 'number')
  if (value && typeof value === 'string') {
    const result = parseFloat(value)
    if (Number.isNaN(result))
      throw `Expected string to be able to be parsed into a number, got ${value}`
    return result
  }
  return value as number
}

export const toDate = (dateString: string, format: string = 'DD.MM.YYYY'): Dayjs =>
  dayjs(dateString, format, true)
